// Спільні виправлення для Swappable у сітках (Bracket2…Bracket64).
// Логіку збереження (saveBracket у кожній сітці) не змінює.

function removeOrphanMirrors(swappable) {
  // @shopify/draggable (beta) інколи лишає копію елемента (.draggable-mirror) у сітці —
  // для порожніх слотів це видно як "///"
  if (swappable && swappable.isDragging && swappable.isDragging()) {
    return;
  }
  document.querySelectorAll('.draggable-mirror').forEach(mirror => mirror.remove());
}

export function guardSwappable(swappable) {
  // порожній слот можна лише замінити спортсменом, але не тягнути сам:
  // інакше випадковий клік зі зсувом мишки запускає "перетягування" і зайве збереження
  swappable.on('drag:start', (event) => {
    if (event.source && event.source.classList.contains('empty')) {
      event.cancel();
    }
  });

  swappable.on('drag:stop', () => {
    setTimeout(() => removeOrphanMirrors(swappable), 0);
    setTimeout(() => removeOrphanMirrors(swappable), 300);
  });
}
